import { Component, OnInit } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { environment } from 'src/environments/environment'
import { ProviderStatusEntry } from './shared/base-shipping-provider.service'
import { AramexSettingsService } from './aramex-provider/aramex-settings.service'
import { DhlSettingsService } from './dhl-provider/dhl-settings.service'
import { SmsaSettingsService } from './smsa-provider/smsa-settings.service'
import { AymakanSettingsService } from './aymakan-provider/aymakan-settings.service'
import { SettingsService } from '../settings/settings.service'

const GCC_COUNTRIES = new Set(['AE', 'SA', 'KW', 'BH', 'QA', 'OM'])

@Component({
  selector: 'app-shipping-providers',
  templateUrl: './shipping-providers.component.html',
  styleUrls: ['../../integrations/integrations.component.scss', './shipping-providers-theme.scss']
})
export class ShippingProvidersComponent implements OnInit {
  activePanelType: string | null = null
  projectId = ''
  isGccCompany = true
  isSaudiCompany = false

  constructor(
    public readonly builderService: BuilderService,
    private readonly http: HttpClient,
    private readonly aramexService: AramexSettingsService,
    private readonly dhlService: DhlSettingsService,
    private readonly smsaService: SmsaSettingsService,
    private readonly aymakanService: AymakanSettingsService,
    private readonly settingsService: SettingsService
  ) {}

  ngOnInit(): void {
    this.projectId = String(this.builderService.getSelectedProject())
    this.loadAllProviders()
    this.settingsService.getSettings().subscribe((settings) => {
      const country: string = settings?.companyCountry ?? ''
      const upper = country.toUpperCase()
      this.isGccCompany = !country || GCC_COUNTRIES.has(upper)
      this.isSaudiCompany = !country || upper === 'SA'
    })
  }

  /**
   * Fetches all provider statuses in a single request and distributes each entry
   * to the corresponding provider service, avoiding redundant network calls.
   */
  async loadAllProviders(): Promise<void> {
    try {
      const token = this.builderService.getToken()
      const headers = new HttpHeaders({ Authorization: `Bearer ${token}` })
      const url = `${environment.agentsUrl}shipping/admin/providers?projectId=${this.projectId}`
      const response = await this.http.get<{ data: ProviderStatusEntry[] }>(url, { headers }).toPromise()
      const entries = response!.data
      const find = (key: string) => entries.find((e) => e.provider === key) ?? null
      this.aramexService.applyEntry(find('aramex'))
      this.dhlService.applyEntry(find('dhl'))
      this.smsaService.applyEntry(find('smsa'))
      this.aymakanService.applyEntry(find('aymakan'))
    } catch {}
  }

  openPanel(type: string): void {
    this.activePanelType = type
  }

  closePanel(): void {
    this.activePanelType = null
  }
}
